import { useState, useCallback, useContext } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { MarktingContext } from "../../Context/MarktingContext";
import { useNavigate } from "react-router-dom";

export default function Resolved({ comentId, resolvedStatus, loginToken, archived }) {
  const [isChecked, setIsChecked] = useState(resolvedStatus && resolvedStatus);
  const { marktingData, setMarktingData } = useContext(MarktingContext);
const [loading, setLoading] = useState(false);

  const navigation = useNavigate();
  const UpdateResolved = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/comment/${comentId}`,
        { resolved: !isChecked },
        {
          headers: {
            Authorization: `Bearer ${loginToken}`,
          },
        }
      );

      if (res.status === 200 && res.data.resolved.status !== isChecked) {
        setIsChecked(res.data.resolved.status);

        const deepCopy = JSON.parse(JSON.stringify(marktingData));

        const element = deepCopy.find((item) =>
          item?.Comments.some(comment => comment.id === comentId) ||
          item?.version?.some(version => version?.Comments.some(comment => comment.id === comentId))
        );

        if (element) {
          // Update the comment in the main Comments array
          const commentIndex = element.Comments.findIndex(comment => comment.id === comentId);
          if (commentIndex !== -1) {
            element.Comments[commentIndex].resolved = res.data.resolved.status;
            element.Comments[commentIndex].resolvedAt = res.data.resolved.resolvedAt;
            element.Comments[commentIndex].resolvedBy = res.data.resolved.resolvedBy;
          } else {
            // If not found in main Comments, search in version Comments
            element.version.forEach(version => {
              const versionCommentIndex = version.Comments.findIndex(comment => comment.id === comentId);
              if (versionCommentIndex !== -1) {
                version.Comments[versionCommentIndex].resolved = res.data.resolved.status;
                version.Comments[versionCommentIndex].resolvedAt = res.data.resolved.resolvedAt;
                version.Comments[versionCommentIndex].resolvedBy = res.data.resolved.resolvedBy;
              }
            });
          }
          // Update the state with the modified deep copy
          setMarktingData(deepCopy);
        }
        setLoading(false);
      }


    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("Firebase Auth");
        localStorage.removeItem("okta-token-storage");
        localStorage.removeItem("okta-cache-storage");
        navigation('/');
        // console.error("session expired");
        return;
      };
      // console.error("Failed to update resolved state:", error);
    }
  }, [comentId, isChecked, marktingData]);

  return (
    !archived ? <button
      className="btn d-flex align-items-center gap-2 px-3 py-2 rounded-3 shadow-sm bg-white "
      style={{
        fontSize: '0.9rem',
        border: '1px solid #B3B3B3 ',
        color: 'rgba(11, 11, 11, 1)',
      }}
      onClick={UpdateResolved}
    >
      <motion.div
        className="d-flex justify-content-center align-items-center rounded-circle"
        style={{
          width: '24px',
          height: '24px',
          border: '1px solid #B3B3B3',
          cursor: 'pointer',
          userSelect: 'none',
          backgroundColor: isChecked ? 'rgba(77, 30, 77, 0.1)' : 'transparent',
        }}
        whileTap={{ scale: 0.9 }}
        whileHover={{ backgroundColor: 'rgba(77, 30, 77, 0.2)' }}
      >
        {!isChecked ? (
          <motion.span
            key="check"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300 }}
            className="text-success"
            style={{ fontSize: '0.8rem' }}
          >
            ✔
          </motion.span>
        ) : (
          <motion.span
            key="cross"
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 10, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="text-danger"
            style={{ fontSize: '0.8rem' }}
          >
            ❌
          </motion.span>
        )}
      </motion.div>
      <span style={{ fontWeight: '500' }}>{!isChecked ? 'Resolved' : "Unresolved"}
        {/* spier loading */}
        {loading ? <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span> : ""}
      </span>
    </button> : ""
  );
}
